/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export abstract class PrePrintDataService {
   public abstract checkPrinterList(callback): Promise<any>;
   public abstract getExchangePrinterList(callback): Promise<any>;
   public abstract constructExchangeClientInfoReply();
}
